import { render, staticRenderFns } from "./transactionRecord.vue?vue&type=template&id=5c9f659d&scoped=true"
import script from "./transactionRecord.vue?vue&type=script&lang=js"
export * from "./transactionRecord.vue?vue&type=script&lang=js"
import style0 from "./transactionRecord.vue?vue&type=style&index=0&id=5c9f659d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f659d",
  null
  
)

export default component.exports